import { Link } from 'react-router-dom';

const HERO_IMAGE =
  'https://roadtechservices.netlify.app/images/hero_img-1920w.jpeg';

const certs = [
  'Briggs & Stratton Master Certified',
  'Stihl Silver Level',
  'Kohler Certified',
  'Kawasaki Certified',
];

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="Road Tech Services mobile equipment repair"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/65 to-black/30" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 w-full pt-20">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-orange-600/20 border border-orange-500/40 text-orange-400 text-xs font-semibold uppercase tracking-widest px-4 py-2 rounded-full mb-7">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shield-check-line text-sm" />
            </div>
            Certified. Reliable. On-Site.
          </div>

          {/* Headline */}
          <h1 className="font-display text-5xl lg:text-7xl xl:text-8xl font-extrabold text-white uppercase tracking-tight leading-none mb-3">
            Expert Mobile
          </h1>
          <h1 className="font-display text-5xl lg:text-7xl xl:text-8xl font-extrabold text-orange-500 uppercase tracking-tight leading-none mb-6">
            Equipment Repair
          </h1>

          <p className="text-white/80 text-lg leading-relaxed mb-8 max-w-xl">
            We come to you. Lawn mowers, snow blowers, and generators serviced
            right at your home by a Briggs &amp; Stratton Master Certified
            technician. No hauling. Same-day service when possible.
          </p>

          <div className="flex flex-wrap gap-4 mb-12">
            <Link
              to="/services"
              className="bg-orange-600 hover:bg-orange-700 text-white font-semibold px-8 py-4 rounded-lg transition-all whitespace-nowrap text-sm tracking-wide cursor-pointer"
            >
              Explore Services
            </Link>
            <Link
              to="/contact"
              className="bg-white/10 hover:bg-white/20 border border-white/30 text-white font-semibold px-8 py-4 rounded-lg transition-all whitespace-nowrap text-sm tracking-wide backdrop-blur-sm cursor-pointer"
            >
              Get a Quote
            </Link>
          </div>

          {/* Cert strip */}
          <div className="flex flex-wrap gap-x-6 gap-y-3">
            {certs.map((cert) => (
              <div key={cert} className="flex items-center gap-2 text-white/70 text-xs">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-orange-400 text-base" />
                </div>
                {cert}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll hint */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/40">
        <span className="text-xs uppercase tracking-widest">Scroll</span>
        <div className="w-px h-10 bg-gradient-to-b from-white/40 to-transparent" />
      </div>
    </section>
  );
}
